import React, { memo } from 'react';
import { useAppContext } from '@prisjakt/ui-app-context';

import * as S from './styles';
import { TooltipPlacement } from '../tooltip-new';
import { IconCompare } from '@prisjakt/ui/icon';

type Props = {
  active: boolean;
  activate: () => void;
  className?: string;
  deactivate: () => void;
};

const CompareProductsToggle = ({
  active,
  activate,
  className,
  deactivate,
}: Props) => {
  const { t } = useAppContext();
  const label = active
    ? t('product', 'product-compare.cancel-compare')
    : t('product', 'product-compare.choose-products');

  return (
    <S.Tooltip
      placement={TooltipPlacement.LEFT}
      title={label}
      className={className}
    >
      <S.CompareProductButtonMobile
        color="primary"
        selected={active}
        onClick={active ? deactivate : activate}
        aria-label={label}
        variant="outlined"
        icon={<IconCompare size={24} />}
      >
        <S.Title>{t('product', 'product-compare.compare')}</S.Title>
      </S.CompareProductButtonMobile>
      <S.CompareProductButtonDesktop
        onClick={active ? deactivate : activate}
        aria-label={label}
      >
        <S.CompareIconWrapper active={active}>
          <IconCompare size={24} />
        </S.CompareIconWrapper>
      </S.CompareProductButtonDesktop>
    </S.Tooltip>
  );
};

export default memo(CompareProductsToggle);
